import styled from "styled-components";

export const MainDiv = styled.div`
  background: #F6F6F8;
  height: auto;
  overflow: hidden;
`;